import { render, staticRenderFns } from "./ModalFormAccess.vue?vue&type=template&id=6fa967e2&scoped=true&"
import script from "./ModalFormAccess.vue?vue&type=script&lang=js&"
export * from "./ModalFormAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa967e2",
  null
  
)

export default component.exports